module.exports = __webpack_public_path__ + "img/titleist_back_img2.b56284b1.png";